<template>
  <Row>
    <Col span="24"
      ><p class="kanbanDes">
        <label>作业车辆</label><span>{{ carNum }}台</span><label>作业线路</label
        ><span>{{ routeNum }}条</span>
      </p></Col
    >
    <Col
      span="24"
      style="text-align: center; margin-bottom: 20px; margin-top: 20px"
    >
      <i-circle
        :percent="attdRate"
        :size="120"
        :trail-width="10"
        trail-color="#163358"
        :stroke-width="10"
        stroke-color="#3ebaf7"
      >
        <p style="font-size: 28px; margin-bottom: 10px; color: #3ebaf7">
          {{ attdRate }}
        </p>
        <p style="color: #9ec9fa">完成率/%</p>
      </i-circle>
    </Col>
    <Col span="24">
      <Row style="text-align: center">
        <Col span="8"
          ><h2 class="ewlcrrw">{{ total }}</h2>
          <p>应作业里程</p></Col
        >
        <Col span="8">
          <h2 class="ewlcrrw">{{ onLine }}</h2>
          <p>现作业里程</p>
        </Col>
        <Col span="8">
          <h2 class="ewlcrrw">{{ duration }}</h2>
          <p>累计时长/分</p>
        </Col>
      </Row>
    </Col>
  </Row>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      onLine: 0,
      duration: 0,
      total: 0,
      item: {},
      attdRate: 0,
      carNum: 0,
      routeNum: 0,
    };
  },
  methods: {
    zaixianlv(t) {
      var x;
      var d = (t / this.total) * 100;
      x = d.toFixed(2);
      return x;
    },

    getData() {

      axios({
        method: "post",
        url: axios.upf + "/screen/countAttd/gtCar",
        data: this.item,
      }).then((res) => {
        var data = res.data.data;
        this.onLine = data.actualMileage;
        this.duration = data.actualDuration;
        this.total = data.mustMileage;
        this.attdRate = data.finishRate;
        this.routeNum = data.routeNum;
        this.carNum = data.carNum;
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style lang="">
h2.ewlcrrw {
  font-size: 20px;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/control/saodiche.vue